/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AudioArrangementUpdate,
  AudioArrangementUpdateRequest,
  ChannelLogo,
  ChannelLogoRequest,
  MusicVideoDetail,
  PatchedChannelLogoRequest,
  PatchedMusicVideoDetailRequest,
  PatchedVideoRenderPresetRequest,
  TokenRefresh,
  TokenRefreshRequest,
  VideoRenderPreset,
  VideoRenderPresetRequest,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 오디오 어레인지먼트 CRUD + render + create-track.
 */
export const audioArrangementUpdate = (
  id: string,
  audioArrangementUpdateRequest: BodyType<AudioArrangementUpdateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<AudioArrangementUpdate>(
    {
      url: `/api/audio-arrangements/${id}/`,
      method: "PUT",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: audioArrangementUpdateRequest,
    },
    options,
  );
};

export const getAudioArrangementUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof audioArrangementUpdate>>,
    TError,
    { id: string; data: BodyType<AudioArrangementUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof audioArrangementUpdate>>,
  TError,
  { id: string; data: BodyType<AudioArrangementUpdateRequest> },
  TContext
> => {
  const mutationKey = ["audioArrangementUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof audioArrangementUpdate>>,
    { id: string; data: BodyType<AudioArrangementUpdateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return audioArrangementUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AudioArrangementUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof audioArrangementUpdate>>
>;
export type AudioArrangementUpdateMutationBody =
  BodyType<AudioArrangementUpdateRequest>;
export type AudioArrangementUpdateMutationError = ErrorType<unknown>;

export const useAudioArrangementUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof audioArrangementUpdate>>,
      TError,
      { id: string; data: BodyType<AudioArrangementUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof audioArrangementUpdate>>,
  TError,
  { id: string; data: BodyType<AudioArrangementUpdateRequest> },
  TContext
> => {
  const mutationOptions = getAudioArrangementUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * JWT refresh — throttle 면제.

refresh는 사용자 의도가 아닌 axios 인터셉터의 자동 갱신 흐름이라,
auth/anon throttle에 걸리면 정상 사용자가 429를 받게 된다. 보안상
refresh token 자체가 만료되거나 invalid면 401로 거부되므로 brute-force
방어는 그쪽에서 처리됨.
 */
export const authRefresh = (
  tokenRefreshRequest: BodyType<TokenRefreshRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TokenRefresh>(
    {
      url: `/api/auth/refresh/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: tokenRefreshRequest,
      signal,
    },
    options,
  );
};

export const getAuthRefreshMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authRefresh>>,
    TError,
    { data: BodyType<TokenRefreshRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authRefresh>>,
  TError,
  { data: BodyType<TokenRefreshRequest> },
  TContext
> => {
  const mutationKey = ["authRefresh"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authRefresh>>,
    { data: BodyType<TokenRefreshRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return authRefresh(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthRefreshMutationResult = NonNullable<
  Awaited<ReturnType<typeof authRefresh>>
>;
export type AuthRefreshMutationBody = BodyType<TokenRefreshRequest>;
export type AuthRefreshMutationError = ErrorType<unknown>;

export const useAuthRefresh = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authRefresh>>,
      TError,
      { data: BodyType<TokenRefreshRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authRefresh>>,
  TError,
  { data: BodyType<TokenRefreshRequest> },
  TContext
> => {
  const mutationOptions = getAuthRefreshMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 채널 로고 CRUD + 프록시. 모든 접근은 채널 소유자(request.user)로 스코프.
 */
export const channelLogoRetrieve = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ChannelLogo>(
    { url: `/api/channel-logos/${id}/`, method: "GET", signal },
    options,
  );
};

export const getChannelLogoRetrieveQueryKey = (id?: string) => {
  return [`/api/channel-logos/${id}/`] as const;
};

export const getChannelLogoRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof channelLogoRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelLogoRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getChannelLogoRetrieveQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof channelLogoRetrieve>>
  > = ({ signal }) => channelLogoRetrieve(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof channelLogoRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChannelLogoRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof channelLogoRetrieve>>
>;
export type ChannelLogoRetrieveQueryError = ErrorType<unknown>;

export function useChannelLogoRetrieve<
  TData = Awaited<ReturnType<typeof channelLogoRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelLogoRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelLogoRetrieve>>,
          TError,
          Awaited<ReturnType<typeof channelLogoRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChannelLogoRetrieve<
  TData = Awaited<ReturnType<typeof channelLogoRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelLogoRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelLogoRetrieve>>,
          TError,
          Awaited<ReturnType<typeof channelLogoRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChannelLogoRetrieve<
  TData = Awaited<ReturnType<typeof channelLogoRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelLogoRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useChannelLogoRetrieve<
  TData = Awaited<ReturnType<typeof channelLogoRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelLogoRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getChannelLogoRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 채널 로고 CRUD + 프록시. 모든 접근은 채널 소유자(request.user)로 스코프.
 */
export const channelLogoUpdate = (
  id: string,
  channelLogoRequest: BodyType<ChannelLogoRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ChannelLogo>(
    {
      url: `/api/channel-logos/${id}/`,
      method: "PUT",
      headers: { "Content-Type": "multipart/form-data" },
      data: channelLogoRequest,
    },
    options,
  );
};

export const getChannelLogoUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof channelLogoUpdate>>,
    TError,
    { id: string; data: BodyType<ChannelLogoRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof channelLogoUpdate>>,
  TError,
  { id: string; data: BodyType<ChannelLogoRequest> },
  TContext
> => {
  const mutationKey = ["channelLogoUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof channelLogoUpdate>>,
    { id: string; data: BodyType<ChannelLogoRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return channelLogoUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChannelLogoUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof channelLogoUpdate>>
>;
export type ChannelLogoUpdateMutationBody = BodyType<ChannelLogoRequest>;
export type ChannelLogoUpdateMutationError = ErrorType<unknown>;

export const useChannelLogoUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof channelLogoUpdate>>,
      TError,
      { id: string; data: BodyType<ChannelLogoRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof channelLogoUpdate>>,
  TError,
  { id: string; data: BodyType<ChannelLogoRequest> },
  TContext
> => {
  const mutationOptions = getChannelLogoUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 채널 로고 CRUD + 프록시. 모든 접근은 채널 소유자(request.user)로 스코프.
 */
export const channelLogoPartialUpdate = (
  id: string,
  patchedChannelLogoRequest: BodyType<PatchedChannelLogoRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ChannelLogo>(
    {
      url: `/api/channel-logos/${id}/`,
      method: "PATCH",
      headers: { "Content-Type": "multipart/form-data" },
      data: patchedChannelLogoRequest,
    },
    options,
  );
};

export const getChannelLogoPartialUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof channelLogoPartialUpdate>>,
    TError,
    { id: string; data: BodyType<PatchedChannelLogoRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof channelLogoPartialUpdate>>,
  TError,
  { id: string; data: BodyType<PatchedChannelLogoRequest> },
  TContext
> => {
  const mutationKey = ["channelLogoPartialUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof channelLogoPartialUpdate>>,
    { id: string; data: BodyType<PatchedChannelLogoRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return channelLogoPartialUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChannelLogoPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof channelLogoPartialUpdate>>
>;
export type ChannelLogoPartialUpdateMutationBody =
  BodyType<PatchedChannelLogoRequest>;
export type ChannelLogoPartialUpdateMutationError = ErrorType<unknown>;

export const useChannelLogoPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof channelLogoPartialUpdate>>,
      TError,
      { id: string; data: BodyType<PatchedChannelLogoRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof channelLogoPartialUpdate>>,
  TError,
  { id: string; data: BodyType<PatchedChannelLogoRequest> },
  TContext
> => {
  const mutationOptions = getChannelLogoPartialUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 뮤직비디오 CRUD + 생성 액션
 */
export const musicVideoPartialUpdate = (
  id: string,
  patchedMusicVideoDetailRequest: BodyType<PatchedMusicVideoDetailRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<MusicVideoDetail>(
    {
      url: `/api/music-videos/${id}/`,
      method: "PATCH",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: patchedMusicVideoDetailRequest,
    },
    options,
  );
};

export const getMusicVideoPartialUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof musicVideoPartialUpdate>>,
    TError,
    { id: string; data: BodyType<PatchedMusicVideoDetailRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof musicVideoPartialUpdate>>,
  TError,
  { id: string; data: BodyType<PatchedMusicVideoDetailRequest> },
  TContext
> => {
  const mutationKey = ["musicVideoPartialUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof musicVideoPartialUpdate>>,
    { id: string; data: BodyType<PatchedMusicVideoDetailRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return musicVideoPartialUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MusicVideoPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof musicVideoPartialUpdate>>
>;
export type MusicVideoPartialUpdateMutationBody =
  BodyType<PatchedMusicVideoDetailRequest>;
export type MusicVideoPartialUpdateMutationError = ErrorType<unknown>;

export const useMusicVideoPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof musicVideoPartialUpdate>>,
      TError,
      { id: string; data: BodyType<PatchedMusicVideoDetailRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof musicVideoPartialUpdate>>,
  TError,
  { id: string; data: BodyType<PatchedMusicVideoDetailRequest> },
  TContext
> => {
  const mutationOptions = getMusicVideoPartialUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 렌더링 프리셋 CRUD API
 */
export const videoStudioPresets4 = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<VideoRenderPreset>(
    { url: `/api/video-studio/presets/${id}/`, method: "GET", signal },
    options,
  );
};

export const getVideoStudioPresets4QueryKey = (id?: string) => {
  return [`/api/video-studio/presets/${id}/`] as const;
};

export const getVideoStudioPresets4QueryOptions = <
  TData = Awaited<ReturnType<typeof videoStudioPresets4>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof videoStudioPresets4>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getVideoStudioPresets4QueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof videoStudioPresets4>>
  > = ({ signal }) => videoStudioPresets4(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof videoStudioPresets4>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type VideoStudioPresets4QueryResult = NonNullable<
  Awaited<ReturnType<typeof videoStudioPresets4>>
>;
export type VideoStudioPresets4QueryError = ErrorType<unknown>;

export function useVideoStudioPresets4<
  TData = Awaited<ReturnType<typeof videoStudioPresets4>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof videoStudioPresets4>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof videoStudioPresets4>>,
          TError,
          Awaited<ReturnType<typeof videoStudioPresets4>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useVideoStudioPresets4<
  TData = Awaited<ReturnType<typeof videoStudioPresets4>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof videoStudioPresets4>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof videoStudioPresets4>>,
          TError,
          Awaited<ReturnType<typeof videoStudioPresets4>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useVideoStudioPresets4<
  TData = Awaited<ReturnType<typeof videoStudioPresets4>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof videoStudioPresets4>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useVideoStudioPresets4<
  TData = Awaited<ReturnType<typeof videoStudioPresets4>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof videoStudioPresets4>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getVideoStudioPresets4QueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 렌더링 프리셋 CRUD API
 */
export const videoStudioPresets6 = (
  id: string,
  videoRenderPresetRequest: BodyType<VideoRenderPresetRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<VideoRenderPreset>(
    {
      url: `/api/video-studio/presets/${id}/`,
      method: "PUT",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: videoRenderPresetRequest,
    },
    options,
  );
};

export const getVideoStudioPresets6MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof videoStudioPresets6>>,
    TError,
    { id: string; data: BodyType<VideoRenderPresetRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof videoStudioPresets6>>,
  TError,
  { id: string; data: BodyType<VideoRenderPresetRequest> },
  TContext
> => {
  const mutationKey = ["videoStudioPresets6"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof videoStudioPresets6>>,
    { id: string; data: BodyType<VideoRenderPresetRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return videoStudioPresets6(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VideoStudioPresets6MutationResult = NonNullable<
  Awaited<ReturnType<typeof videoStudioPresets6>>
>;
export type VideoStudioPresets6MutationBody =
  BodyType<VideoRenderPresetRequest>;
export type VideoStudioPresets6MutationError = ErrorType<unknown>;

export const useVideoStudioPresets6 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof videoStudioPresets6>>,
      TError,
      { id: string; data: BodyType<VideoRenderPresetRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof videoStudioPresets6>>,
  TError,
  { id: string; data: BodyType<VideoRenderPresetRequest> },
  TContext
> => {
  const mutationOptions = getVideoStudioPresets6MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 렌더링 프리셋 CRUD API
 */
export const videoStudioPresets5 = (
  id: string,
  patchedVideoRenderPresetRequest: BodyType<PatchedVideoRenderPresetRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<VideoRenderPreset>(
    {
      url: `/api/video-studio/presets/${id}/`,
      method: "PATCH",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: patchedVideoRenderPresetRequest,
    },
    options,
  );
};

export const getVideoStudioPresets5MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof videoStudioPresets5>>,
    TError,
    { id: string; data: BodyType<PatchedVideoRenderPresetRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof videoStudioPresets5>>,
  TError,
  { id: string; data: BodyType<PatchedVideoRenderPresetRequest> },
  TContext
> => {
  const mutationKey = ["videoStudioPresets5"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof videoStudioPresets5>>,
    { id: string; data: BodyType<PatchedVideoRenderPresetRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return videoStudioPresets5(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VideoStudioPresets5MutationResult = NonNullable<
  Awaited<ReturnType<typeof videoStudioPresets5>>
>;
export type VideoStudioPresets5MutationBody =
  BodyType<PatchedVideoRenderPresetRequest>;
export type VideoStudioPresets5MutationError = ErrorType<unknown>;

export const useVideoStudioPresets5 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof videoStudioPresets5>>,
      TError,
      { id: string; data: BodyType<PatchedVideoRenderPresetRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof videoStudioPresets5>>,
  TError,
  { id: string; data: BodyType<PatchedVideoRenderPresetRequest> },
  TContext
> => {
  const mutationOptions = getVideoStudioPresets5MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
